/**
 * DroneFeedPanel Component
 *
 * Right panel displaying live drone feed, mission details, and flight controls
 */

import { useState, useEffect, useRef, useCallback } from 'react';
import { cn } from '@/lib/utils';
import styled from 'styled-components';
import Hls from 'hls.js';

interface DroneFeedPanelProps {
  url?: string;
  className?: string;
}

// Styled container untuk player video
// const LiveFeedContainer = styled.div<{ $fullscreen?: boolean }>`
//   position: relative;
//   width: 100%;
//   height: 100%;
//   background: #000;
//   overflow: hidden;
//   box-shadow: ${(props) =>
//     props.$fullscreen ? "none" : "0 4px 16px rgba(0, 0, 0, 0.15)"};

//   .camera-controls {
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     display: flex;
//     flex-direction: column;
//     justify-content: space-between;
//     opacity: 0;
//     transition: opacity 0.3s ease;
//     background: linear-gradient(
//       to bottom,
//       rgba(0, 0, 0, 0.7) 0%,
//       rgba(0, 0, 0, 0) 25%,
//       rgba(0, 0, 0, 0) 75%,
//       rgba(0, 0, 0, 0.7) 100%
//     );
//     pointer-events: none;

//     &:hover {
//       opacity: 1;
//     }

//     & > * {
//       pointer-events: auto;
//     }
//   }

//   .camera-header {
//     display: flex;
//     justify-content: space-between;
//     align-items: flex-start;
//     padding: 12px;
//     width: 100%;
//   }

//   .camera-footer {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding: 12px;
//     width: 100%;
//   }

//   .camera-info {
//     font-size: 13px;
//     color: white;
//     text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
//     max-width: 70%;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     white-space: nowrap;
//   }

//   .live-indicator {
//     display: flex;
//     align-items: center;
//     font-size: 13px;
//     color: white;
//     text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);

//     .dot {
//       height: 8px;
//       width: 8px;
//       background-color: #ff4d4f;
//       border-radius: 50%;
//       margin-right: 6px;
//       animation: pulse 1.5s infinite;
//       box-shadow: 0 0 5px rgba(255, 77, 79, 0.6);
//     }
//   }

//   .camera-button {
//     background: rgba(0, 0, 0, 0.5);
//     border: none;
//     color: white;
//     width: 32px;
//     height: 32px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     border-radius: 4px;
//     transition: all 0.2s ease;
//     margin-left: 4px;

//     &:hover {
//       background: rgba(0, 0, 0, 0.7);
//       color: white;
//       transform: translateY(-2px);
//       box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
//     }

//     &:active {
//       transform: translateY(0);
//     }
//   }

//   .loading-container {
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     align-items: center;
//     height: 100%;
//     background: linear-gradient(135deg, #131313 0%, #1f1f1f 100%);
//     color: rgba(255, 255, 255, 0.85);

//     .loading-text {
//       margin-top: 12px;
//       font-size: 14px;
//     }
//   }

//   .camera-error {
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     align-items: center;
//     background-color: rgba(0, 0, 0, 0.8);
//     color: #ff4d4f;
//     text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
//   }

//   .warning-icon {
//     font-size: 40px;
//     margin-bottom: 16px;
//     color: #ff4d4f;
//     filter: drop-shadow(0 0 10px rgba(255, 77, 79, 0.5));
//   }

//   @keyframes pulse {
//     0% {
//       opacity: 1;
//       transform: scale(1);
//     }
//     50% {
//       opacity: 0.5;
//       transform: scale(0.8);
//     }
//     100% {
//       opacity: 1;
//       transform: scale(1);
//     }
//   }

//   &[data-fullscreen="true"] {
//     position: fixed;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     width: 100vw;
//     height: 100vh;
//     z-index: 9999;
//     background: #000;
//   }
// `;


const VideoContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background: #000;
`;

// const StatusBadge = styled.div<{ $isOnline?: boolean }>`
//   position: absolute;
//   top: 40px;
//   left: 8px;
//   background: ${(props) =>
//     props.$isOnline ? "rgba(82, 196, 26, 0.9)" : "rgba(255, 77, 79, 0.9)"};
//   color: white;
//   padding: 4px 8px;
//   border-radius: 4px;
//   font-size: 10px;
//   z-index: 10;
//   font-weight: 500;
// `;


const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
`;


const RetryInfo = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.8);
  color: #faad14;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 12px;
  z-index: 15;
  text-align: center;
  border: 1px solid #faad14;
`;

/**
 * Video Player Component with HLS streaming and auto-retry
 */
interface VideoPlayerProps {
  src: string;
  cameraNumber: number;
  isOnline: boolean;
  onError?: (error: string) => void;
}

const VideoPlayer = ({ src, cameraNumber, isOnline: _isOnline, onError }: VideoPlayerProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const hlsRef = useRef<Hls | null>(null);
  const retryCountRef = useRef<number>(0);
  const retryTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [retryAttempt, setRetryAttempt] = useState(0);

  const MAX_RETRY_ATTEMPTS = 10;
  const RETRY_DELAY = 3000;

  const initializeHls = useCallback(() => {
    const video = videoRef.current;
    if (!video || !src) return;

    console.log(
      `🎬 [Attempt ${retryCountRef.current + 1}] Loading HLS stream for camera ${cameraNumber}:`,
      src
    );

    // Don't destroy if already playing the same source
    if (hlsRef.current && hlsRef.current.url === src && video.readyState >= 2) {
      console.log(`✅ HLS already playing for camera ${cameraNumber}, skipping re-initialization`);
      return;
    }

    // Destroy previous HLS instance if exists
    if (hlsRef.current) {
      console.log(`🔄 Destroying previous HLS instance for camera ${cameraNumber}`);
      hlsRef.current.destroy();
      hlsRef.current = null;
    }

    // Check if HLS.js is supported
    if (Hls.isSupported()) {
      const hls = new Hls({
        enableWorker: true,
        lowLatencyMode: true,
        backBufferLength: 90,
        maxBufferLength: 30,
        maxMaxBufferLength: 60,
      });

      hlsRef.current = hls;

      hls.loadSource(src);
      hls.attachMedia(video);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        console.log(`✅ HLS manifest parsed for camera ${cameraNumber}`);
        retryCountRef.current = 0;
        setRetryAttempt(0);
        setError(null);

        video
          .play()
          .then(() => {
            setIsPlaying(true);
            console.log(`▶️ Video playing for camera ${cameraNumber}`);
          })
          .catch((err) => {
            console.error(`❌ Failed to play video:`, err);
            setError("Failed to play video");
          });
      });

      hls.on(Hls.Events.ERROR, (_, data) => {
        console.error(`❌ HLS error for camera ${cameraNumber}:`, data);

        if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              console.log(
                `🔄 Network error, attempting to recover... (Attempt ${retryCountRef.current + 1
                }/${MAX_RETRY_ATTEMPTS})`
              );

              if (retryCountRef.current < MAX_RETRY_ATTEMPTS) {
                hls.startLoad();

                retryTimeoutRef.current = setTimeout(() => {
                  retryCountRef.current++;
                  setRetryAttempt(retryCountRef.current);
                  console.log(`🔄 Retrying HLS connection for camera ${cameraNumber}...`);
                  initializeHls();
                }, RETRY_DELAY);
              } else {
                console.error(`❌ Max retry attempts reached for camera ${cameraNumber}`);
                const errorMsg = `Connection failed after ${MAX_RETRY_ATTEMPTS} attempts`;
                setError(errorMsg);
                if (onError) onError(errorMsg);
                hls.destroy();
              }
              break;

            case Hls.ErrorTypes.MEDIA_ERROR:
              console.log(`🔄 Media error, attempting to recover...`);
              hls.recoverMediaError();

              setTimeout(() => {
                if (!hlsRef.current || hlsRef.current.media?.error) {
                  if (retryCountRef.current < MAX_RETRY_ATTEMPTS) {
                    retryCountRef.current++;
                    setRetryAttempt(retryCountRef.current);
                    console.log(`🔄 Media recovery failed, retrying...`);
                    initializeHls();
                  } else {
                    const errorMsg = `Media error after ${MAX_RETRY_ATTEMPTS} attempts`;
                    setError(errorMsg);
                    if (onError) onError(errorMsg);
                    hls.destroy();
                  }
                }
              }, RETRY_DELAY);
              break;

            default:
              console.error(`❌ Fatal error occurred for camera ${cameraNumber}`);

              if (retryCountRef.current < MAX_RETRY_ATTEMPTS) {
                retryCountRef.current++;
                setRetryAttempt(retryCountRef.current);
                hls.destroy();

                retryTimeoutRef.current = setTimeout(() => {
                  console.log(`🔄 Retrying after fatal error...`);
                  initializeHls();
                }, RETRY_DELAY);
              } else {
                const errorMsg = `Fatal error after ${MAX_RETRY_ATTEMPTS} attempts`;
                setError(errorMsg);
                if (onError) onError(errorMsg);
                hls.destroy();
              }
              break;
          }
        }
      });
    }
    // For Safari and other browsers that support HLS natively
    else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = src;
      video.addEventListener("loadedmetadata", () => {
        video
          .play()
          .then(() => {
            setIsPlaying(true);
            setError(null);
            retryCountRef.current = 0;
            setRetryAttempt(0);
          })
          .catch((err) => {
            console.error(`❌ Failed to play video:`, err);

            if (retryCountRef.current < MAX_RETRY_ATTEMPTS) {
              retryCountRef.current++;
              setRetryAttempt(retryCountRef.current);
              retryTimeoutRef.current = setTimeout(() => {
                console.log(`🔄 Retrying native HLS...`);
                initializeHls();
              }, RETRY_DELAY);
            } else {
              setError("Failed to play video");
            }
          });
      });
    } else {
      setError("HLS is not supported in this browser");
    }
  }, [src, cameraNumber]);

  useEffect(() => {
    initializeHls();

    return () => {
      console.log(`🧹 Cleaning up HLS for camera ${cameraNumber}`);

      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
        retryTimeoutRef.current = null;
      }

      if (hlsRef.current) {
        hlsRef.current.destroy();
        hlsRef.current = null;
      }

      retryCountRef.current = 0;
    };
  }, [src, cameraNumber]); // Removed initializeHls from dependencies to prevent re-initialization loop

  if (error) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "#ff4d4f",
          fontSize: "12px",
          textAlign: "center",
        }}
      >
        <div>❌ {error}</div>
        <div style={{ fontSize: "10px", marginTop: "8px" }}>Camera {cameraNumber}</div>
        {retryAttempt > 0 && (
          <div style={{ fontSize: "10px", marginTop: "4px", color: "#faad14" }}>
            Retry attempts: {retryAttempt}/{MAX_RETRY_ATTEMPTS}
          </div>
        )}
      </div>
    );
  }

  return (
    <VideoContainer>
      <StyledVideo ref={videoRef} autoPlay muted playsInline controls />
      {retryAttempt > 0 && !isPlaying && (
        <RetryInfo>
          <div>🔄 Reconnecting...</div>
          <div style={{ fontSize: "9px", marginTop: "2px" }}>
            Attempt {retryAttempt}/{MAX_RETRY_ATTEMPTS}
          </div>
        </RetryInfo>
      )}
    </VideoContainer>
  );
};


export function DroneFeedPanel({ url, className }: DroneFeedPanelProps) {
  const [flightTime, setFlightTime] = useState(23 * 60 + 45); // 23:45 in seconds
  const [totalFlightTime] = useState(35 * 60 + 8); // 35:08 in seconds
  const [isLive, setIsLive] = useState(true);

  useEffect(() => {
    if (!isLive) return;

    const interval = setInterval(() => {
      setFlightTime((prev) => {
        if (prev >= totalFlightTime) {
          setIsLive(false);
          return totalFlightTime;
        }
        return prev + 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isLive, totalFlightTime]);

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  const remainingTime = totalFlightTime - flightTime;
  const progress = (flightTime / totalFlightTime) * 100;

  return (
    <div
      className={cn(
        'bg-slate-900/95 backdrop-blur-sm border border-slate-700 rounded-lg shadow-2xl',
        'flex flex-col h-full overflow-hidden flex-1',
        className
      )}
    >
      {/* Header */}
      <div className="px-3 py-2 border-slate-700 flex-shrink-0">
        <h2 className="text-sm font-semibold text-white">Aerial • Infrastructure Inspection</h2>
        <p className="text-xs text-slate-400 mt-0.5">TR-1 Reconnaissance Drone</p>
      </div>

      <div className="relative px-3 py-2 h-48 rounded-md overflow-hidden bg-black">
        {url ? (
          <VideoPlayer src={url} cameraNumber={1} isOnline={true} onError={(err) => console.error('Video error:', err)} />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-slate-800">
            <div className="text-center">
              <div className="text-slate-400 text-sm mb-2">📹 No Stream Available</div>
              <div className="text-slate-500 text-xs">Waiting for stream URL...</div>
            </div>
          </div>
        )}
      </div>

      {/* Source Video */}
      <div className="px-3 py-3 flex-shrink-0 rounded-md">
        <div className="bg-slate-800/50 px-3 py-2 rounded-md ">
          <label className="text-xs text-slate-400 block mb-1">Source Video</label>
          <div className="flex flex-row mb-4 gap-2">
            <button className="bg-[#1C5CAA] hover:bg-blue-700 text-white py-1.5 px-2 rounded transition-colors flex items-center justify-center text-xs">
              Smart Camera
            </button>
            <button className="bg-slate-700 hover:bg-blue-700 text-white py-1.5 px-2 rounded transition-colors flex items-center justify-center text-xs">
              Drone Camera
            </button>
          </div>
        </div>
      </div>

      {/* Mission Details */}
      <div className="px-3 py-3 space-y-2.5 flex-shrink-0 rounded-md">

        <div className="bg-slate-800/50 px-3 py-2 rounded-md ">
          <label className="text-xs text-slate-400 block mb-1">Mission</label>
          <div className=" bg-slate-700 p-2 rounded-md mb-4">

            <p className="text-sm text-white font-medium">Mission-A332</p>
          </div>

          <label className="text-xs text-slate-400 block mb-1">Pilot</label>
          <div className=" bg-slate-700 p-2 rounded-md mb-4">
            <p className="text-sm text-white font-medium">Jhon Doe</p>

          </div>

          <label className="text-xs text-slate-400 block mb-1">Start Time</label>
          <div className=" bg-slate-700 p-2 rounded-md mb-4">
            <p className="text-sm text-white font-medium">11:32:21 AM</p>
          </div>

          <label className="text-xs text-slate-400 block mb-1">Description</label>
          <div className=" bg-slate-700 p-2 rounded-md mb-4">
            <p className="text-sm text-white font-medium">-</p>
          </div>
        </div>

      </div>

      {/* Flight Time Progress */}
      <div className="px-3 py-3 flex-shrink-0 ">
        <div className="bg-slate-800/50 px-3 py-2 rounded-md">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs text-slate-400">Flight Time</span>
            <span className="text-sm text-white font-medium">{formatTime(flightTime)}</span>
          </div>
          <div className="w-full bg-slate-700 rounded-full h-2 mb-2">
            <div
              className="bg-[#1C5CAA] h-2 rounded-full transition-all duration-1000"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <p className="text-xs text-slate-400">Remaining: {formatTime(remainingTime)}</p>
        </div>
      </div>

      {/* Finish Flight Button */}
      <div className="mt-auto px-3 py-3 flex-shrink-0">
        <button className="w-full bg-[#1C5CAA] hover:bg-blue-700 text-white font-medium py-2.5 px-3 rounded transition-colors flex items-center justify-center gap-2 text-sm">
          Finish Flight
        </button>
      </div>
    </div >
  );
}

